import serialStatusEnum from './serialStatus'
import warrantyTypeEnum from './warrantyType'
import bannerStatusEnum from './bannerStatus'
import instructionsStatusEnum from './instructionsStatus'

import Enum from './enum'
const serialStatus = new Enum(serialStatusEnum)
const bannerStatus = new Enum(bannerStatusEnum)
const warrantyType = new Enum(warrantyTypeEnum)
const instructionsStatus = new Enum(instructionsStatusEnum)

export default {
  serialStatus,
  warrantyType,
  bannerStatus,
  instructionsStatus
}
